import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { constructProductSliderData } from "../../utils/shop";

// Components
import {
  ShopifyProductSlider,
  ShopifyProductSliderItem,
} from "../Molecules/ShopifyProductSlider";

// Stylesheets
import "./FeaturedProductsSection.scss";

export const SubCollectionProductItems = ({
  productData,
  index,
  itemListName,
}) => (
  <ShopifyProductSliderItem
    key={index}
    productData={productData}
    itemListName={itemListName}
  />
);

SubCollectionProductItems.propTypes = {
  productData: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
};

const getBackgroundColor = (style = null) => {
  if (style && style.sectionBackground) {
    return { style: { backgroundColor: style.sectionBackground } };
  }
};

export const FeaturedProductsSection = ({
  subCollectionData,
  renderHeader,
  staticData,
  className,
  productList,
  productLimit,
  columns,
  itemListName,
  ...otherProps
}) => {
  let componentClassName;

  if (columns === 4) {
    componentClassName = classNames(
      "subcollection_featured_products_section",
      "subcollection_featured_products_section_4_columns",
      "section",
      className
    );
  } else {
    componentClassName = classNames(
      "subcollection_featured_products_section",
      "subcollection_featured_products_section_4_columns",
      "section",
      className
    );
  }

  const productSliderData = constructProductSliderData(
    Object.values(productList)
  );

  if (productList.length === 0) {
    return null;
  }

  return (
    <section
      className={componentClassName}
      {...getBackgroundColor(staticData.styles)}
      {...otherProps}
    >
      <div className="container">
        {renderHeader({ subCollectionData, staticData })}
        <ShopifyProductSlider
          itemListName={itemListName}
          productList={productSliderData}
          productLimit={productLimit}
          renderItems={SubCollectionProductItems}
        />
      </div>
    </section>
  );
};

FeaturedProductsSection.propTypes = {
  className: PropTypes.any,
  renderHeader: PropTypes.func,
  productList: PropTypes.arrayOf(PropTypes.object).isRequired,
  productLimit: PropTypes.number,
  columns: PropTypes.number,
  itemListName: PropTypes.string,
  subCollectionData: PropTypes.shape({
    metadata: PropTypes.shape({
      description: PropTypes.string,
      image: PropTypes.object,
      title: PropTypes.string,
      handle: PropTypes.string,
    }),
  }).isRequired,
  staticData: PropTypes.object.isRequired,
};

FeaturedProductsSection.defaultProps = {
  renderHeader: () => {},
};

export default FeaturedProductsSection;
